// Take a thing and test to see if it is something (not null / undefined)
// The `maybeThing is T` means this can be used in an Array.filter(...) to remove nulls / undefineds with type safety
export const isSomething = <T>(maybeThing: T | null | undefined): maybeThing is T => maybeThing !== null && maybeThing !== undefined

/**
 * Returns the first element of a list when used like this:
 * ```[ 1, 2, 3 ].find(firstElement)```
 */
export const firstElement = () => true
